export async function mapTransfers(items, concurrency, transfer) {
  if (!Number.isInteger(concurrency) || concurrency < 1 || concurrency > 8) throw new Error("Invalid transfer concurrency.");
  const results = new Array(items.length);let next = 0, failure;
  const check = () => { if (failure) throw failure; };
  async function worker() {
    while (!failure) {
      const index = next++;if (index >= items.length) return;
      try { results[index] = await transfer(items[index], index, check); }
      catch (error) { failure ??= error; }
    }
  }
  // Drain all started requests before returning a failure or allowing a retry.
  await Promise.all(Array.from({ length: Math.min(concurrency, items.length) }, worker));
  check();return results;
}
